import {AdminPagingModel} from "./AdminPagingModel";
import {Template} from "../../entities/Template";
import {TemplateService} from "../../services/TemplateService";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";

export class TemplateAdminPagingModel extends AdminPagingModel<Template>{
    static $inject = ['$q','TemplateService','NotificationService','GridBookmarkService'];
    constructor($q:ng.IQService, pagingService:TemplateService,notificationService:NotificationService,
                gridBookmarkService:GridBookmarkService){
        super($q, pagingService,notificationService,gridBookmarkService);
    }
    getCustomActions():string[]{
        return [];
    }
    entityName():string{
        return "template";
    }
    displayName():string{
        return "Print Templates";
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs = [['name','Name', null],['templatetype','Print Type', null]];
        return this.$q.when();
    }
}
